// extracted by mini-css-extract-plugin
export default {"tag":"Person__tag___N0h62","closeIcon":"Person__closeIcon___ZaRZB","personName":"Person__personName___iwdt3","restoreCheckbox":"Person__restoreCheckbox___mZy3D"};